<!--
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2021-12-02 09:36:33
 * @LastEditors: Jerry
 * @LastEditTime: 2021-12-02 14:58:35
-->

<template>
  <!-- 领取成功弹窗 -->
  <div>
    <el-dialog
      title="支付成功"
      :visible.sync="dialogSucceed"
      width="864px"
      :before-close="handleClose"
    >
      <div class="container">
        <img :src="require('../../../../assets/BrokerageCity/successed.png')" alt="">
        <div>优惠券已放入您的【我的优惠券】中</div>
        <div class="btns">
          <el-button @click="goPage('MyCoupon')">查看优惠券</el-button>
          <el-button type="primary" @click="goPage('BrokerageCity')">返回券商城</el-button>
        </div>

      </div>

    </el-dialog>

  </div>
</template>
<script>
export default {
  name: 'PaySuccessed',
  components: {},
  mixins: [],
  data() {
    return {
      dialogSucceed: false
    }
  },
  computed: {},
  watch: {},
  // 生命周期
  created() { },
  mounted() { },
  unmounted() {
    this.dialogSucceed = false
  },
  // 方法
  methods: {
    show() {
      this.dialogSucceed = true
    },
    handleClose() {
      this.$router.push({
        name: 'BrokerageCity'
      })
    },
    goPage(name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog__header {
  background: rgba(239, 239, 239, 1);
}

.container {
  background: rgba(255, 255, 255, 1);

  img {
    margin: 50px auto 30px;
    width: 121px;
    height: 121px;
  }

  span {
    font-size: 22px;
    font-weight: 400;
    text-align: center;
    color: #111A34;
  }

  .btns {
    margin-top: 78px;
  }
}
</style>
